// extracted by mini-css-extract-plugin
export var matchList__ads__container = "list-module--matchList__ads__container--tihPq";
export var matchList__ads__item = "list-module--matchList__ads__item--ZX5Il";
export var matchList__content = "list-module--matchList__content--A7+H0";
export var matchList__content__list = "list-module--matchList__content__list--AeO0i";
export var matchList__content__scrollDown = "list-module--matchList__content__scrollDown--y6143";
export var matchList__seasonHeader = "list-module--matchList__seasonHeader--ETcjh";
export var matchList__seasonHeader__dropdown = "list-module--matchList__seasonHeader__dropdown--+Vaez";